const DTMF_FREQS: Record<string, [number, number]> = {
	'1': [697, 1209],
	'2': [697, 1336],
	'3': [697, 1477],
	'4': [770, 1209],
	'5': [770, 1336],
	'6': [770, 1477],
	'7': [852, 1209],
	'8': [852, 1336],
	'9': [852, 1477],
	'*': [941, 1209],
	'0': [941, 1336],
	'#': [941, 1477]
};

export class Beech_audio {
	private audio: HTMLAudioElement;
	private ringback: HTMLAudioElement;
	private ctx: AudioContext | null = null;

	public constructor() {
		logg.log('audio >> init');

		this.audio = new Audio('/audio/login.mp3');
		this.ringback = new Audio('/audio/ringing.mp3');
		this.ringback.loop = true;
	}

	public playLogin = (): void => {
		this.audio.play().catch((error) => {
			console.error('audio >> playLogin >> error', error);
		});
	};

	public startRingback = (): void => {
		if (!this.ringback.paused) return;

		this.ringback.currentTime = 0;
		this.ringback.play().catch(() => {});
	};

	public stopRingback = (): void => {
		if (this.ringback.paused) return;

		this.ringback.pause();
		this.ringback.currentTime = 0;
	};

	public playLobbyChime = (): void => {
		try {
			if (!this.ctx) this.ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
			const ctx = this.ctx;

			const now = ctx.currentTime;
			const noteDuration = 0.22;
			const gap = 0.18;

			const notes: [number, number][] = [
				[523.25, now], // C5
				[659.25, now + noteDuration + gap] // E5 (soft third)
			];

			for (const [freq, start] of notes) {
				const gain = ctx.createGain();
				gain.gain.setValueAtTime(0, start);
				gain.gain.linearRampToValueAtTime(0.08, start + 0.02);
				gain.gain.exponentialRampToValueAtTime(0.001, start + noteDuration);
				gain.connect(ctx.destination);

				const osc = ctx.createOscillator();
				osc.type = 'sine';
				osc.frequency.value = freq;
				osc.connect(gain);
				osc.start(start);
				osc.stop(start + noteDuration);
			}
		} catch (err) {
			logg.warn('audio >> playLobbyChime >> error', err);
		}
	};

	public playDtmf = (digit: string): void => {
		const pair = DTMF_FREQS[digit];
		if (!pair) return;

		try {
			if (!this.ctx) this.ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
			const ctx = this.ctx;

			const now = ctx.currentTime;
			const duration = 0.12;

			const gain = ctx.createGain();
			gain.gain.setValueAtTime(0, now);
			gain.gain.linearRampToValueAtTime(0.2, now + 0.005);
			gain.gain.setValueAtTime(0.2, now + duration - 0.02);
			gain.gain.linearRampToValueAtTime(0, now + duration);
			gain.connect(ctx.destination);

			for (const freq of pair) {
				const osc = ctx.createOscillator();
				osc.type = 'sine';
				osc.frequency.value = freq;
				osc.connect(gain);
				osc.start(now);
				osc.stop(now + duration);
			}
		} catch (err) {
			logg.warn('audio >> playDtmf >> error', err);
		}
	};
}
